import axios from 'axios';
import { restUrls } from '@/api/rest/url.js'

const FavoriteMenu = {
    addFavoriteMenu: (params) => axios.post(restUrls.add_favorite_menu,params),
    cancelFavoriteMenu: (params) => axios.post(restUrls.cancel_favorite_menu,params),
    queryFavoriteMenuList: () => axios.post(restUrls.query_favorite_menu_list),
    modifyFavoriteMenu: (params) => axios.post(restUrls.modify_favorite_menu,params),
}
export default FavoriteMenu;